import type React from 'react';
import type {ClipSchema} from '../../../../core/entities/clip/schema';
import {FavoriteButton} from '../../../../shared/components/FavoriteButton';
import {useHandleReportClip} from '../../usecases/useHandleReportClip';

type ClipContentProps = {
  clip: ClipSchema;
};

export const ClipFavoriteButtonForReport: React.FC<ClipContentProps> = ({
  clip,
}) => {
  const {handleClip, clipCountUpdated, isClipped} = useHandleReportClip({
    reportId: clip.content.id,
    reportType: clip.type,
    clipCount: clip.clipCount,
    clippedAt: clip.clippedAt,
  });

  return (
    <FavoriteButton
      count={`${clipCountUpdated}`}
      isClipped={isClipped}
      handleUpdate={handleClip}
    />
  );
};
